import React from 'react';
import MobilePDFViewer from '../components/MobilePDFViewer';

const Viewer: React.FC = () => {
    return <MobilePDFViewer />;
};

export default Viewer;
